
export default function ClientStories() {
  const engagements = [
    {
      title: 'Home Services',
      description: 'Reduced manual coordination and improved multi-location visibility.',
      icon: 'ri-home-4-line'
    },
    {
      title: 'Med Spa',
      description: 'Streamlined intake, scheduling, and follow-up workflows.',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: 'Real Estate',
      description: 'Faster transaction cycles and clearer process ownership.',
      icon: 'ri-building-line'
    },
    {
      title: 'Staffing / Recruiting',
      description: 'Improved pipeline movement and recruiter efficiency.',
      icon: 'ri-team-line'
    },
    {
      title: 'Payroll / HR / ERP',
      description: 'Reduced payroll preparation time and improved accuracy.',
      icon: 'ri-file-list-3-line'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Representative Engagements
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {engagements.map((engagement, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-200 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${engagement.icon} text-3xl text-blue-500 group-hover:scale-110 transition-transform`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {engagement.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {engagement.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-xs text-gray-500 italic">
            Composite examples illustrating Annalogix's approach to workflow architecture.
          </p>
        </div>
      </div>
    </section>
  );
}
